import { render } from "./konamiCode.vue?vue&type=template&id=7b92bb4c&scoped=true"
import script from "./konamiCode.vue?vue&type=script&lang=js"
export * from "./konamiCode.vue?vue&type=script&lang=js"

import "./konamiCode.vue?vue&type=style&index=0&id=7b92bb4c&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b92bb4c"]])

export default __exports__